import React, { useEffect, useState } from "react";
import { MessageCircle, Send, X } from "lucide-react";
import { toast } from "sonner";
import { messageTemplates, sendMessage } from "../lib/api";

export default function QuickMessageModal({ open, onClose, dosyaId, dosyaNo }) {
    const [templates, setTemplates] = useState([]);
    const [channel, setChannel] = useState("whatsapp");
    const [template, setTemplate] = useState("eksik_evrak");
    const [extra, setExtra] = useState("");
    const [sending, setSending] = useState(false);

    useEffect(() => {
        if (!open) return;
        messageTemplates()
            .then((d) => setTemplates(d.templates || []))
            .catch(() => {});
    }, [open]);

    if (!open) return null;

    async function handleSend() {
        setSending(true);
        try {
            const res = await sendMessage({
                channel,
                template,
                dosya_id: dosyaId,
                context: { mesaj: extra },
            });
            if (res.ok) {
                toast.success(channel === "whatsapp" ? "WhatsApp gönderildi" : "SMS gönderildi");
            } else {
                toast.error(res.detail || "Gönderilemedi");
            }
            onClose?.();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Gönderim hatası");
        } finally {
            setSending(false);
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/60"
                onClick={onClose}
            />
            <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#121A2F] p-6 shadow-2xl">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <MessageCircle className="h-5 w-5 text-[#D4AF37]" />
                        <h3 className="text-white font-display">Hızlı Mesaj</h3>
                    </div>
                    <button type="button" onClick={onClose} className="text-slate-400 hover:text-white">
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <p className="text-xs text-slate-500 mb-4">Dosya: {dosyaNo}</p>
                <div className="flex gap-2 mb-3">
                    {["whatsapp", "sms"].map((ch) => (
                        <button
                            key={ch}
                            type="button"
                            onClick={() => setChannel(ch)}
                            className={`flex-1 h-9 rounded-md text-xs border ${
                                channel === ch
                                    ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#F3E5AB]"
                                    : "border-white/10 text-slate-400"
                            }`}
                        >
                            {ch === "whatsapp" ? "WhatsApp" : "SMS"}
                        </button>
                    ))}
                </div>
                <label className="text-[10px] uppercase text-slate-500">Şablon</label>
                <select
                    value={template}
                    onChange={(e) => setTemplate(e.target.value)}
                    className="w-full mt-1 mb-3 h-10 rounded-md bg-[#0B0F19] border border-white/10 text-sm text-slate-200 px-2"
                >
                    {templates.map((t) => (
                        <option key={t.key} value={t.key}>
                            {t.label}
                        </option>
                    ))}
                </select>
                <label className="text-[10px] uppercase text-slate-500">Ek mesaj (isteğe bağlı)</label>
                <textarea
                    value={extra}
                    onChange={(e) => setExtra(e.target.value)}
                    rows={3}
                    className="w-full mt-1 mb-4 rounded-md bg-[#0B0F19] border border-white/10 text-sm text-slate-200 p-2"
                />
                <button
                    type="button"
                    disabled={sending}
                    onClick={handleSend}
                    className="w-full h-10 rounded-md bg-[#D4AF37] text-slate-900 font-semibold text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50"
                >
                    <Send className="h-4 w-4" />
                    Gönder
                </button>
            </div>
        </div>
    );
}
